import { render } from "./NurseCallsHistory.vue?vue&type=template&id=26edf795&scoped=true"
import script from "./NurseCallsHistory.vue?vue&type=script&lang=js"
export * from "./NurseCallsHistory.vue?vue&type=script&lang=js"

import "./NurseCallsHistory.vue?vue&type=style&index=0&id=26edf795&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26edf795"]])

export default __exports__